<template>
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <path
      d="M12 2C11.2044 2 10.4413 2.29349 9.87868 2.81592C9.31607 3.33834 9 4.0469 9 4.78571V12.2143C9 12.9531 9.31607 13.6617 9.87868 14.1841C10.4413 14.7065 11.2044 15 12 15C12.7956 15 13.5587 14.7065 14.1213 14.1841C14.6839 13.6617 15 12.9531 15 12.2143V4.78571C15 4.0469 14.6839 3.33834 14.1213 2.81592C13.5587 2.29349 12.7956 2 12 2V2Z"
      stroke="#596A73"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M19 10V12C19 13.8565 18.2625 15.637 16.9497 16.9497C15.637 18.2625 13.8565 19 12 19C10.1435 19 8.36301 18.2625 7.05025 16.9497C5.7375 15.637 5 13.8565 5 12V10"
      stroke="#596A73"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path d="M12 19V22" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M8 22H16" stroke="#596A73" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>
</template>
